import {
  REPORT_PDF_PREFLIGHT_MAX_BYTES,
  type ReportPhotoInput,
  reportPhotoInputSchema,
} from "@mytour/shared";
import {compressPhotoFile} from "./file.util.js";

export class ReportPhotoPreparationError extends Error {
  constructor() {
    super(
      "Le PDF avec ces photos ne peut pas être finalisé. Retirez ou remplacez une photo, puis réessayez. Vos saisies sont conservées."
    );
  }
}

export async function prepareReportPhotos(
  photos: ReportPhotoInput[],
  render: (photos: ReportPhotoInput[]) => Promise<Blob>,
  compress: typeof compressPhotoFile = compressPhotoFile
): Promise<{photos: ReportPhotoInput[]; blob: Blob}> {
  let prepared = photos;
  try {
    for (const photo of photos) {
      reportPhotoInputSchema.parse(photo);
    }
    for (const maxBytes of [0, 160 * 1024, 100 * 1024]) {
      if (maxBytes) {
        const compressed: ReportPhotoInput[] = [];
        for (const photo of prepared) {
          const bytes = Uint8Array.from(
            atob(photo.dataUrl.slice("data:image/jpeg;base64,".length)),
            (char) => char.charCodeAt(0)
          );
          compressed.push(
            bytes.length <= maxBytes
              ? photo
              : {
                  ...photo,
                  dataUrl: await compress(new File([bytes], "photo.jpg", {type: "image/jpeg"}), {
                    maxLongSide: 1600,
                    targetBytes: maxBytes,
                    maxBytes,
                  }),
                }
          );
        }
        prepared = compressed;
      }
      const blob = await render(prepared);
      if (blob.size <= REPORT_PDF_PREFLIGHT_MAX_BYTES) {
        return {photos: prepared, blob};
      }
    }
  } catch {
    throw new ReportPhotoPreparationError();
  }
  throw new ReportPhotoPreparationError();
}
